import { get, patch, post, put } from '../../utils/http';

export const addPublication = ({ accountId, ...params }) => post(`/accounts/${accountId}/publications`, params);

export const fetchPublication = ({ accountId, publicationId }) =>
  get(`/accounts/${accountId}/publications/${publicationId}`);

export const updatePublication = ({ accountId, publicationId, ...params }) =>
  put(`/accounts/${accountId}/publications/${publicationId}`, params);

export const updatePublicationInfo = ({ accountId, publicationId, ...params }) =>
  patch(`/accounts/${accountId}/publications/${publicationId}`, params);

export const notifyPublication = ({ accountId, publicationId, ...params }) =>
  post(`/accounts/${accountId}/publications/${publicationId}/notification`, params);

export const fetchPublicationsBatch = ({ accountId, publicationIds }) =>
  get(`/accounts/${accountId}/publications/batch`, { publicationIds });

export const notifyBulkPublication = ({ accountId, publicationIds, ...params }) =>
  post(`/accounts/${accountId}/publications/notification`, { ids: publicationIds, ...params });
